import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    // Tracking Temporary
    {
        path: '/trackingtemp/',
        name: 'Tracking Termporary',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.tlv1.read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import('@/router/views/trackingtemp/')
    },

    {
        path: '/trackingtemp/create',
        name: 'Tracking Termporary Add',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Create', _)
                if (store.state.access.data.tlv1.create) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import('@/router/views/trackingtemp/form')
    },

    {
        path: '/trackingtemp/update/:id',
        name: 'Tracking Termporary Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Update', _)
                if (store.state.access.data.tlv1.update) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import('@/router/views/trackingtemp/form')
    },

    {
        path: '/trackingtemp/liveview',
        name: 'Tracking Termporary Map',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.tlv1.read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import('@/router/views/trackingtemp/liveview')
    },

    {
        path: '/fleet/live-track/:id',
        name: 'Tracking Termporary Liveview',
        meta: {
            guestPage: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                next();
            }
        },
        component: () =>
            import('@/router/views/trackingtemp/liveview')
    },
]